import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom";
import CheckLatestVersion from "./components/CheckLatestVersion";
import AppContext from "./context";
import { BillingPlansProvider } from "./context/billingPlans";
import { CommentsProvider } from "./context/comments";
import { CommissionReportsProvider } from "./context/commissionReports";
import { CommissionTemplatesProvider } from "./context/commissionTemplates";
import { ContactsProvider } from "./context/contacts";
import { HotspotMakersProvider } from "./context/hotspotMakers";
import { HotspotsProvider } from "./context/hotspots";
import { InstallsProvider } from "./context/installs";
import { LabelsProvider } from "./context/labels";
import { LineOfSightProvider } from "./context/lineOfSight";
import { LocationsProvider } from "./context/locations";
import { MembersProvider } from "./context/members";
import { MessagesProvider } from "./context/messages";
import { NotificationSubscriptionsProvider } from "./context/notificationSubscriptions";
import { PaymentTransactionsProvider } from "./context/paymentTransactions";
import { PlacementsProvider } from "./context/placements";
import { TooCloseToWitnessProvider } from "./context/tooCloseToWitness";
import { TransmitScalesProvider } from "./context/transmitScales";
import { WalletsProvider } from "./context/wallets";
import OAuth2Loader, { AuthorizationCodeGrant } from "./pages/OAuth2Loader";
import Routes from "./routes";

interface Props {}

const App: React.FC<Props> = () => (
  <Router>
    <AppContext>
      <CheckLatestVersion />
      <Switch>
        <Redirect exact from="/" to={`hotspots${window.location.search}`} />
        <Route
          exact
          path="/auth/discord"
          render={() => (
            <OAuth2Loader
              step={AuthorizationCodeGrant.AuthorizationRequest}
              provider="discord"
            />
          )}
        />
        <Route
          exact
          path="/auth/google"
          render={() => (
            <OAuth2Loader
              step={AuthorizationCodeGrant.AuthorizationRequest}
              provider="google"
            />
          )}
        />
        <Route
          exact
          path="/auth/apple"
          render={() => (
            <OAuth2Loader
              step={AuthorizationCodeGrant.AuthorizationRequest}
              provider="apple"
            />
          )}
        />
        <Route
          exact
          path="/auth/discord/cb"
          render={() => (
            <OAuth2Loader
              step={AuthorizationCodeGrant.AuthorizationResponse}
              provider="discord"
            />
          )}
        />
        <NotificationSubscriptionsProvider>
          <BillingPlansProvider>
            <CommentsProvider>
              <LabelsProvider>
                <CommissionTemplatesProvider>
                  <WalletsProvider>
                    <PlacementsProvider>
                      <LineOfSightProvider>
                        <HotspotsProvider>
                          <HotspotMakersProvider>
                            <MessagesProvider>
                              <ContactsProvider>
                                <MembersProvider>
                                  <LocationsProvider>
                                    <InstallsProvider>
                                      <TransmitScalesProvider>
                                        <PaymentTransactionsProvider>
                                          <CommissionReportsProvider>
                                            <TooCloseToWitnessProvider>
                                              <Routes />
                                            </TooCloseToWitnessProvider>
                                          </CommissionReportsProvider>
                                        </PaymentTransactionsProvider>
                                      </TransmitScalesProvider>
                                    </InstallsProvider>
                                  </LocationsProvider>
                                </MembersProvider>
                              </ContactsProvider>
                            </MessagesProvider>
                          </HotspotMakersProvider>
                        </HotspotsProvider>
                      </LineOfSightProvider>
                    </PlacementsProvider>
                  </WalletsProvider>
                </CommissionTemplatesProvider>
              </LabelsProvider>
            </CommentsProvider>
          </BillingPlansProvider>
        </NotificationSubscriptionsProvider>
      </Switch>
    </AppContext>
  </Router>
);

export default App;
